import { render, staticRenderFns } from "./CommentFill.vue?vue&type=template&id=2cf198c4&"
import script from "./CommentFill.vue?vue&type=script&lang=js&"
export * from "./CommentFill.vue?vue&type=script&lang=js&"
import style0 from "./CommentFill.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports